import './index.less';
import { cdnUrl } from '@/utils/cdn';

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-main">
        <img src={cdnUrl("/img/slerf/footer-logo.svg")} alt="" />
        SlerfTools&copy; 2025
      </div>
    </div>
  );
}
